import { NamedDiscoveryConfig } from './NamedDiscoveryConfig.ts';

export class KubernetesConfig extends NamedDiscoveryConfig<KubernetesConfig> {
    constructor() {
        super("kubernetes");
    }
}
